export const isLoggedUser = (token) => token.get();
